/**
 * Tracks whether a child/student has an academic-context reset (US-PRF-01)
 * pending a fresh timetable upload — purely a frontend signal so the dashboard
 * can show a high-priority banner if the user drops off before uploading a new
 * schedule (US-PRF-02). Wrapped in try/catch since localStorage can throw in
 * some private-browsing contexts; a lost flag just means the banner doesn't
 * show, never a crash.
 */

const KEY_PREFIX = 'vado_timetable_required_';

export function markTimetableRequired(childId: string): void {
  try {
    localStorage.setItem(`${KEY_PREFIX}${childId}`, '1');
  } catch {
    // ignore — non-critical
  }
}

export function clearTimetableRequired(childId: string): void {
  try {
    localStorage.removeItem(`${KEY_PREFIX}${childId}`);
  } catch {
    // ignore — non-critical
  }
}

export function isTimetableRequired(childId: string | null | undefined): boolean {
  if (!childId) return false;
  try {
    return localStorage.getItem(`${KEY_PREFIX}${childId}`) === '1';
  } catch {
    return false;
  }
}
